/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_beneficiaryAboutYouData } from '../models/api_beneficiaryAboutYouData';
import type { api_beneficiaryAdditionalInformationData } from '../models/api_beneficiaryAdditionalInformationData';
import type { api_beneficiaryEducationHistoryData } from '../models/api_beneficiaryEducationHistoryData';
import type { api_beneficiaryEmploymentData } from '../models/api_beneficiaryEmploymentData';
import type { api_beneficiaryEqualOpportunityData } from '../models/api_beneficiaryEqualOpportunityData';
import type { api_beneficiaryEssayData } from '../models/api_beneficiaryEssayData';
import type { api_beneficiaryImmigrationData } from '../models/api_beneficiaryImmigrationData';
import type { api_beneficiaryPersonalData } from '../models/api_beneficiaryPersonalData';
import type { api_beneficiaryPostScholarshipPlanData } from '../models/api_beneficiaryPostScholarshipPlanData';
import type { api_BeneficiaryProposedCourse } from '../models/api_BeneficiaryProposedCourse';
import type { api_beneficiaryProposedCourseData } from '../models/api_beneficiaryProposedCourseData';
import type { api_BeneficiaryProposedCourseTask } from '../models/api_BeneficiaryProposedCourseTask';
import type { api_beneficiaryRecommenderData } from '../models/api_beneficiaryRecommenderData';
import type { api_createBeneficiaryContactRequest } from '../models/api_createBeneficiaryContactRequest';
import type { api_createBeneficiaryContactResponse } from '../models/api_createBeneficiaryContactResponse';
import type { api_createBeneficiaryEligibilityVerificationRequest } from '../models/api_createBeneficiaryEligibilityVerificationRequest';
import type { api_createBeneficiaryEligibilityVerificationResponse } from '../models/api_createBeneficiaryEligibilityVerificationResponse';
import type { api_createBeneficiaryEmploymentResponse } from '../models/api_createBeneficiaryEmploymentResponse';
import type { api_createBeneficiaryInteractionHistoryRequest } from '../models/api_createBeneficiaryInteractionHistoryRequest';
import type { api_createBeneficiaryInteractionHistoryResponse } from '../models/api_createBeneficiaryInteractionHistoryResponse';
import type { api_createBeneficiaryInterviewOutcomeRequest } from '../models/api_createBeneficiaryInterviewOutcomeRequest';
import type { api_createBeneficiaryInterviewOutcomeResponse } from '../models/api_createBeneficiaryInterviewOutcomeResponse';
import type { api_createBeneficiaryNextOfKinRequest } from '../models/api_createBeneficiaryNextOfKinRequest';
import type { api_createBeneficiaryNextOfKinResponse } from '../models/api_createBeneficiaryNextOfKinResponse';
import type { api_createBeneficiaryPartnerRequest } from '../models/api_createBeneficiaryPartnerRequest';
import type { api_createBeneficiaryRequest } from '../models/api_createBeneficiaryRequest';
import type { api_createJobResponse } from '../models/api_createJobResponse';
import type { api_exportApplicationPDFsParams } from '../models/api_exportApplicationPDFsParams';
import type { api_getAuthenticatedBeneficiaryResponse } from '../models/api_getAuthenticatedBeneficiaryResponse';
import type { api_getBeneficiaryAssessmentResponse } from '../models/api_getBeneficiaryAssessmentResponse';
import type { api_getBeneficiaryCommitteeAssessmentResponse } from '../models/api_getBeneficiaryCommitteeAssessmentResponse';
import type { api_getBeneficiaryPlacementStatusResponse } from '../models/api_getBeneficiaryPlacementStatusResponse';
import type { api_getBeneficiaryRecommenderResponse } from '../models/api_getBeneficiaryRecommenderResponse';
import type { api_getBeneficiaryRecoveryCodeResponse } from '../models/api_getBeneficiaryRecoveryCodeResponse';
import type { api_getBeneficiaryRecoveryDataResponse } from '../models/api_getBeneficiaryRecoveryDataResponse';
import type { api_getUnauthenticatedBeneficiaryResponse } from '../models/api_getUnauthenticatedBeneficiaryResponse';
import type { api_listApplicationTasksResponse } from '../models/api_listApplicationTasksResponse';
import type { api_listBeneficiaryAssessmentsByBeneficiaryIDResponse } from '../models/api_listBeneficiaryAssessmentsByBeneficiaryIDResponse';
import type { api_listBeneficiaryEmploymentByBeneficiaryIDResponse } from '../models/api_listBeneficiaryEmploymentByBeneficiaryIDResponse';
import type { api_listBeneficiaryTasksResponse } from '../models/api_listBeneficiaryTasksResponse';
import type { api_passportData } from '../models/api_passportData';
import type { api_previewBeneficiaryInterviewLetterResponse } from '../models/api_previewBeneficiaryInterviewLetterResponse';
import type { api_rejectApplicationsRequest } from '../models/api_rejectApplicationsRequest';
import type { api_resendRecommenderEmailRequest } from '../models/api_resendRecommenderEmailRequest';
import type { api_resetBeneficiaryDataRequest } from '../models/api_resetBeneficiaryDataRequest';
import type { api_resetDeferredPlacementRequest } from '../models/api_resetDeferredPlacementRequest';
import type { api_returnApplicationRequest } from '../models/api_returnApplicationRequest';
import type { api_sendBeneficiaryReminderEmailRequest } from '../models/api_sendBeneficiaryReminderEmailRequest';
import type { api_sendBeneficiaryTokenEmailRequest } from '../models/api_sendBeneficiaryTokenEmailRequest';
import type { api_sendRecoveryCodeEmailRequest } from '../models/api_sendRecoveryCodeEmailRequest';
import type { api_sendRecoveryCodeSmsRequest } from '../models/api_sendRecoveryCodeSmsRequest';
import type { api_shareApplicationWithAdvisorRequest } from '../models/api_shareApplicationWithAdvisorRequest';
import type { api_signLetterRequest } from '../models/api_signLetterRequest';
import type { api_submitApplicationRequest } from '../models/api_submitApplicationRequest';
import type { api_switchApplicationSessionResponse } from '../models/api_switchApplicationSessionResponse';
import type { api_updateBeneficiaryAcademicAssessmentRequest } from '../models/api_updateBeneficiaryAcademicAssessmentRequest';
import type { api_updateBeneficiaryBudgetRequest } from '../models/api_updateBeneficiaryBudgetRequest';
import type { api_updateBeneficiaryCasNumberRequest } from '../models/api_updateBeneficiaryCasNumberRequest';
import type { api_updateBeneficiaryCertifiedEducationHistoryRequest } from '../models/api_updateBeneficiaryCertifiedEducationHistoryRequest';
import type { api_updateBeneficiaryCollegeOfferLetterRequest } from '../models/api_updateBeneficiaryCollegeOfferLetterRequest';
import type { api_updateBeneficiaryContactPersonRequestBody } from '../models/api_updateBeneficiaryContactPersonRequestBody';
import type { api_updateBeneficiaryDocumentSelfResponse } from '../models/api_updateBeneficiaryDocumentSelfResponse';
import type { api_updateBeneficiaryEducationHistoryDataResponse } from '../models/api_updateBeneficiaryEducationHistoryDataResponse';
import type { api_updateBeneficiaryEmailRequest } from '../models/api_updateBeneficiaryEmailRequest';
import type { api_updateBeneficiaryEmploymentRequest } from '../models/api_updateBeneficiaryEmploymentRequest';
import type { api_updateBeneficiaryEmploymentTaskStatusRequest } from '../models/api_updateBeneficiaryEmploymentTaskStatusRequest';
import type { api_updateBeneficiaryFlagRequest } from '../models/api_updateBeneficiaryFlagRequest';
import type { api_updateBeneficiaryGenderRequest } from '../models/api_updateBeneficiaryGenderRequest';
import type { api_updateBeneficiaryHealthConditionsParams } from '../models/api_updateBeneficiaryHealthConditionsParams';
import type { api_updateBeneficiaryInteractionHistoryRequest } from '../models/api_updateBeneficiaryInteractionHistoryRequest';
import type { api_updateBeneficiaryInterestRequest } from '../models/api_updateBeneficiaryInterestRequest';
import type { api_updateBeneficiaryInterviewSlotRequest } from '../models/api_updateBeneficiaryInterviewSlotRequest';
import type { api_updateBeneficiaryLetterRequest } from '../models/api_updateBeneficiaryLetterRequest';
import type { api_updateBeneficiaryPlacementRequest } from '../models/api_updateBeneficiaryPlacementRequest';
import type { api_updateBeneficiaryProgrammeOfficersRequest } from '../models/api_updateBeneficiaryProgrammeOfficersRequest';
import type { api_updateBeneficiaryProposedCourseIsFinalRequestBody } from '../models/api_updateBeneficiaryProposedCourseIsFinalRequestBody';
import type { api_updateBeneficiaryProposedCourseRequestBody } from '../models/api_updateBeneficiaryProposedCourseRequestBody';
import type { api_updateBeneficiaryProposedCourseStatusRequest } from '../models/api_updateBeneficiaryProposedCourseStatusRequest';
import type { api_updateBeneficiaryRequest } from '../models/api_updateBeneficiaryRequest';
import type { api_updateBeneficiarySelfRequest } from '../models/api_updateBeneficiarySelfRequest';
import type { api_updateBeneficiarySelfResponse } from '../models/api_updateBeneficiarySelfResponse';
import type { api_updateBeneficiarySocialMediaRequest } from '../models/api_updateBeneficiarySocialMediaRequest';
import type { api_updateBeneficiarySpecialStatusesRequest } from '../models/api_updateBeneficiarySpecialStatusesRequest';
import type { api_updateBeneficiaryStatusesRequest } from '../models/api_updateBeneficiaryStatusesRequest';
import type { api_updateBeneficiaryStudyYearRequest } from '../models/api_updateBeneficiaryStudyYearRequest';
import type { api_updateBeneficiarySurveyData } from '../models/api_updateBeneficiarySurveyData';
import type { api_updateBeneficiaryTravelBookingStatusRequest } from '../models/api_updateBeneficiaryTravelBookingStatusRequest';
import type { api_validateBeneficiaryAccessCodeRequest } from '../models/api_validateBeneficiaryAccessCodeRequest';
import type { api_validateBeneficiaryEmailRequest } from '../models/api_validateBeneficiaryEmailRequest';
import type { api_validateBeneficiaryKBVRequest } from '../models/api_validateBeneficiaryKBVRequest';
import type { api_validateBeneficiaryTaskRequest } from '../models/api_validateBeneficiaryTaskRequest';
import type { api_validateBeneficiaryTokenResponse } from '../models/api_validateBeneficiaryTokenResponse';
import type { api_validateEducationHistoryTokenResponse } from '../models/api_validateEducationHistoryTokenResponse';
import type { api_validateRecommenderTokenResponse } from '../models/api_validateRecommenderTokenResponse';
import type { api_validateRecoveryCodeRequest } from '../models/api_validateRecoveryCodeRequest';
import type { api_validateRecoveryCodeResponse } from '../models/api_validateRecoveryCodeResponse';
import type { api_verifyBeneficiaryAccessCodeRequest } from '../models/api_verifyBeneficiaryAccessCodeRequest';
import type { api_verifyBeneficiaryAccessCodeResponse } from '../models/api_verifyBeneficiaryAccessCodeResponse';
import type { api_withdrawOfferRequest } from '../models/api_withdrawOfferRequest';
import type { db_BeneficiaryBeneficiarySocialMedium } from '../models/db_BeneficiaryBeneficiarySocialMedium';
import type { db_BeneficiaryRecommender } from '../models/db_BeneficiaryRecommender';
import type { db_BeneficiaryTaskMap } from '../models/db_BeneficiaryTaskMap';
import type { db_DropdownSpecialStatus } from '../models/db_DropdownSpecialStatus';
import type { db_GetBeneficiaryDashboardCountsRow } from '../models/db_GetBeneficiaryDashboardCountsRow';
import type { db_GetBeneficiaryDashboardJurisdictionalCountsRow } from '../models/db_GetBeneficiaryDashboardJurisdictionalCountsRow';
import type { db_GetBeneficiaryEligibilityStatusCountsRow } from '../models/db_GetBeneficiaryEligibilityStatusCountsRow';
import type { db_GetBeneficiaryEligibilityStatusesRow } from '../models/db_GetBeneficiaryEligibilityStatusesRow';
import type { db_GetBeneficiaryEmploymentRow } from '../models/db_GetBeneficiaryEmploymentRow';
import type { db_GetBeneficiaryInteractionHistoryRow } from '../models/db_GetBeneficiaryInteractionHistoryRow';
import type { db_GetBeneficiaryLetterRow } from '../models/db_GetBeneficiaryLetterRow';
import type { db_GetBeneficiaryPendingTaskCountsRow } from '../models/db_GetBeneficiaryPendingTaskCountsRow';
import type { db_GetBeneficiaryPlacementRow } from '../models/db_GetBeneficiaryPlacementRow';
import type { db_GetBeneficiaryRejectionValidationCountsRow } from '../models/db_GetBeneficiaryRejectionValidationCountsRow';
import type { db_GetBeneficiaryRow } from '../models/db_GetBeneficiaryRow';
import type { db_GetInterviewOutcomeByBeneficiaryIDRow } from '../models/db_GetInterviewOutcomeByBeneficiaryIDRow';
import type { db_GetInterviewSlotForBeneficiaryRow } from '../models/db_GetInterviewSlotForBeneficiaryRow';
import type { db_ListBeneficiariesCustomRow } from '../models/db_ListBeneficiariesCustomRow';
import type { db_ListBeneficiaryBudgetByBeneficiaryIDRow } from '../models/db_ListBeneficiaryBudgetByBeneficiaryIDRow';
import type { db_ListBeneficiaryCommitteeAssessmentsRow } from '../models/db_ListBeneficiaryCommitteeAssessmentsRow';
import type { db_ListBeneficiaryContactPersonByBeneficiaryIDRow } from '../models/db_ListBeneficiaryContactPersonByBeneficiaryIDRow';
import type { db_ListBeneficiaryContactsByBeneficiaryIDRow } from '../models/db_ListBeneficiaryContactsByBeneficiaryIDRow';
import type { db_ListBeneficiaryDocumentsByBeneficiaryIDRow } from '../models/db_ListBeneficiaryDocumentsByBeneficiaryIDRow';
import type { db_ListBeneficiaryEducationHistoryByBeneficiaryIDRow } from '../models/db_ListBeneficiaryEducationHistoryByBeneficiaryIDRow';
import type { db_ListBeneficiaryEmailByBeneficiaryIDRow } from '../models/db_ListBeneficiaryEmailByBeneficiaryIDRow';
import type { db_ListBeneficiaryEthnicityByBeneficiaryIDRow } from '../models/db_ListBeneficiaryEthnicityByBeneficiaryIDRow';
import type { db_ListBeneficiaryInteractionHistoryRow } from '../models/db_ListBeneficiaryInteractionHistoryRow';
import type { db_ListBeneficiaryInterestByBeneficiaryIDRow } from '../models/db_ListBeneficiaryInterestByBeneficiaryIDRow';
import type { db_ListBeneficiaryNextOfKinByBeneficiaryIDRow } from '../models/db_ListBeneficiaryNextOfKinByBeneficiaryIDRow';
import type { db_ListBeneficiaryPartnersByBeneficiaryIDRow } from '../models/db_ListBeneficiaryPartnersByBeneficiaryIDRow';
import type { db_ListBeneficiaryProposedCoursesByBeneficiaryIDRow } from '../models/db_ListBeneficiaryProposedCoursesByBeneficiaryIDRow';
import type { db_ListBeneficiaryRecommendersByBeneficiaryIDRow } from '../models/db_ListBeneficiaryRecommendersByBeneficiaryIDRow';
import type { db_ListBeneficiaryStudyYearByBeneficiaryIDRow } from '../models/db_ListBeneficiaryStudyYearByBeneficiaryIDRow';
import type { db_ListBeneficiaryTagsByBeneficiaryIDRow } from '../models/db_ListBeneficiaryTagsByBeneficiaryIDRow';
import type { db_ListBeneficiaryTravelByBeneficiaryIDRow } from '../models/db_ListBeneficiaryTravelByBeneficiaryIDRow';
import type { db_ListInterviewSchedulesRow } from '../models/db_ListInterviewSchedulesRow';
import type { db_ListInterviewSlotsRow } from '../models/db_ListInterviewSlotsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Beneficiaries {
    /**
     * Get a list of beneficiaries
     * @param pageId Page ID
     * @param pageSize Page size
     * @param columns Columns
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @param isCount Is count
     * @returns db_ListBeneficiariesCustomRow OK
     * @throws ApiError
     */
    public static listBeneficiaries(
        pageId: number,
        pageSize: number,
        columns?: string,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
        isCount?: boolean,
    ): CancelablePromise<Array<db_ListBeneficiariesCustomRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'columns': columns,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
                'is_count': isCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a beneficiary record
     * @param body Beneficiary details
     * @returns void
     * @throws ApiError
     */
    public static createBeneficiary(
        body: api_createBeneficiaryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary record (self, token)
     * @param body Beneficiary details
     * @returns api_updateBeneficiarySelfResponse OK
     * @throws ApiError
     */
    public static updateBeneficiarySelf(
        body: api_updateBeneficiarySelfRequest,
    ): CancelablePromise<api_updateBeneficiarySelfResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's about you data
     * @returns api_beneficiaryAboutYouData OK
     * @throws ApiError
     */
    public static getBeneficiaryAboutYouData(): CancelablePromise<api_beneficiaryAboutYouData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/about-you-data',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's about you data (self, token)
     * @param body Beneficiary about you data
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryAboutYouData(
        body: api_updateBeneficiarySurveyData,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/about-you-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Accept an offer for a beneficiary
     * @returns void
     * @throws ApiError
     */
    public static acceptOffer(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/accept-offer',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's additional information data
     * @returns api_beneficiaryAdditionalInformationData OK
     * @throws ApiError
     */
    public static getBeneficiaryAdditionalInformationData(): CancelablePromise<api_beneficiaryAdditionalInformationData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/additional-information-data',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's additional information data (self, token)
     * @param body Beneficiary additional information data
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryAdditionalInformationData(
        body: api_updateBeneficiarySurveyData,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/additional-information-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of tasks for authenticated applicant
     * @returns api_listApplicationTasksResponse OK
     * @throws ApiError
     */
    public static listApplicationTasks(): CancelablePromise<api_listApplicationTasksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/application-tasks',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update special status of beneficiaries
     * @param body Beneficiary IDs and Special Status ID
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiarySpecialStatuses(
        body: api_updateBeneficiarySpecialStatusesRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/beneficiaries/beneficiary-special-statuses',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update status of beneficiaries
     * @param body Beneficiary IDs and Status ID
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryStatuses(
        body: api_updateBeneficiaryStatusesRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/beneficiaries/beneficiary-statuses',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's CAS number (self, token)
     * @param body CAS number
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryCasNumber(
        body: api_updateBeneficiaryCasNumberRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/cas-number',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's certified education history ID (self, token)
     * @param body Certified education history ID
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryCertifiedEducationHistory(
        body: api_updateBeneficiaryCertifiedEducationHistoryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/certified-education-history',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's client care letter (self, token)
     * @param body Client care letter
     * @returns void
     * @throws ApiError
     */
    public static signClientCareLetter(
        body: api_signLetterRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/client-care-letter',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's college offer letter (self, token)
     * @param body Proposed course status ID
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryCollegeOfferLetter(
        body: api_updateBeneficiaryCollegeOfferLetterRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/college-offer-letter',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a beneficiary contact record
     * @param body Contact details
     * @returns api_createBeneficiaryContactResponse OK
     * @throws ApiError
     */
    public static createBeneficiaryContact(
        body: api_createBeneficiaryContactRequest,
    ): CancelablePromise<api_createBeneficiaryContactResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/contacts',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get dashboard counts for beneficiaries
     * @returns db_GetBeneficiaryDashboardCountsRow OK
     * @throws ApiError
     */
    public static getBeneficiaryDashboardCounts(): CancelablePromise<db_GetBeneficiaryDashboardCountsRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/dashboard-counts',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get dashboard counts for jurisdictional beneficiaries
     * @returns db_GetBeneficiaryDashboardJurisdictionalCountsRow OK
     * @throws ApiError
     */
    public static getBeneficiaryDashboardJurisdictionalCounts(): CancelablePromise<db_GetBeneficiaryDashboardJurisdictionalCountsRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/dashboard-counts/jurisdictional',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Defer a beneficiary's offer
     * @param deferralReasonDetails
     * @param deferralReasonId
     * @param email
     * @param file File to be uploaded
     * @returns void
     * @throws ApiError
     */
    public static deferOffer(
        deferralReasonDetails: string,
        deferralReasonId: number,
        email: string,
        file?: Blob,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/defer-offer',
            formData: {
                'file': file,
                'deferral_reason_details': deferralReasonDetails,
                'deferral_reason_id': deferralReasonId,
                'email': email,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary document (self, token)
     * @param documentFile Document file
     * @param documentType Document type
     * @param studyYear Study year (1, 2, 3)
     * @param dateOfBirth Date of birth
     * @param certifiedEducationHistoryId Certified education history ID
     * @param gpa GPA
     * @returns api_updateBeneficiaryDocumentSelfResponse OK
     * @throws ApiError
     */
    public static updateBeneficiaryDocumentSelf(
        documentFile?: Blob,
        documentType?: string,
        studyYear?: number,
        dateOfBirth?: string,
        certifiedEducationHistoryId?: number,
        gpa?: string,
    ): CancelablePromise<api_updateBeneficiaryDocumentSelfResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/documents',
            formData: {
                'document_file': documentFile,
                'document_type': documentType,
                'study_year': studyYear,
                'date_of_birth': dateOfBirth,
                'certified_education_history_id': certifiedEducationHistoryId,
                'gpa': gpa,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's document
     * @param documentTypeCode Document type code
     * @param isImage Serve as image
     * @returns binary OK
     * @throws ApiError
     */
    public static getBeneficiaryDocumentByType(
        documentTypeCode: string,
        isImage?: boolean,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/documents/type/{document_type_code}',
            path: {
                'document_type_code': documentTypeCode,
            },
            query: {
                'is_image': isImage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                502: `Bad Gateway`,
            },
        });
    }
    /**
     * Get a beneficiary's document
     * @param documentId Document ID
     * @param isImage Serve as image
     * @returns binary OK
     * @throws ApiError
     */
    public static getBeneficiaryDocument(
        documentId: number,
        isImage?: boolean,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/documents/{document_id}',
            path: {
                'document_id': documentId,
            },
            query: {
                'is_image': isImage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                502: `Bad Gateway`,
            },
        });
    }
    /**
     * Get a beneficiary's education history
     * @returns api_beneficiaryEducationHistoryData OK
     * @throws ApiError
     */
    public static getBeneficiaryEducationHistoryData(): CancelablePromise<api_beneficiaryEducationHistoryData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/education-history-data',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's education history (self, token)
     * @param file File to be uploaded
     * @param beneficiaryEducationHistoryId
     * @param countryId
     * @param course
     * @param courseResultScaleId
     * @param degreeType
     * @param endDate
     * @param endorsingInstitutionId
     * @param externalUniversityId
     * @param gpa
     * @param institutionName
     * @param major
     * @param minor
     * @param region
     * @param regionId
     * @param startDate
     * @param transcriptDocumentId
     * @returns api_updateBeneficiaryEducationHistoryDataResponse OK
     * @throws ApiError
     */
    public static updateBeneficiaryEducationHistoryData(
        file?: Blob,
        beneficiaryEducationHistoryId?: number,
        countryId?: number,
        course?: string,
        courseResultScaleId?: number,
        degreeType?: string,
        endDate?: string,
        endorsingInstitutionId?: number,
        externalUniversityId?: number,
        gpa?: string,
        institutionName?: string,
        major?: string,
        minor?: string,
        region?: string,
        regionId?: number,
        startDate?: string,
        transcriptDocumentId?: number,
    ): CancelablePromise<api_updateBeneficiaryEducationHistoryDataResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/education-history-data',
            formData: {
                'file': file,
                'beneficiary_education_history_id': beneficiaryEducationHistoryId,
                'country_id': countryId,
                'course': course,
                'course_result_scale_id': courseResultScaleId,
                'degree_type': degreeType,
                'end_date': endDate,
                'endorsing_institution_id': endorsingInstitutionId,
                'external_university_id': externalUniversityId,
                'gpa': gpa,
                'institution_name': institutionName,
                'major': major,
                'minor': minor,
                'region': region,
                'region_id': regionId,
                'start_date': startDate,
                'transcript_document_id': transcriptDocumentId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a beneficiary's education history
     * @param beneficiaryEducationHistoryId Beneficiary education history ID
     * @returns void
     * @throws ApiError
     */
    public static deleteBeneficiaryEducationHistory(
        beneficiaryEducationHistoryId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/beneficiaries/education-history-data/{beneficiary_education_history_id}',
            path: {
                'beneficiary_education_history_id': beneficiaryEducationHistoryId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's education history task status (self, token)
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryEducationHistoryTaskStatus(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/education-history-task-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get counts of beneficiaries per eligibility status
     * @returns db_GetBeneficiaryEligibilityStatusCountsRow OK
     * @throws ApiError
     */
    public static getBeneficiaryEligibilityStatusCounts(): CancelablePromise<Array<db_GetBeneficiaryEligibilityStatusCountsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/eligibility-to-review-counts',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's employment data
     * @returns api_beneficiaryEmploymentData OK
     * @throws ApiError
     */
    public static getBeneficiaryEmploymentData(): CancelablePromise<api_beneficiaryEmploymentData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/employment-data',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's employment data (self, token)
     * @param body Beneficiary employment data
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryEmploymentData(
        body: api_updateBeneficiaryEmploymentRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/employment-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a beneficiary's employment
     * @param beneficiaryEmploymentId Beneficiary employment ID
     * @returns void
     * @throws ApiError
     */
    public static deleteBeneficiaryEmployment(
        beneficiaryEmploymentId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/beneficiaries/employment-data/{beneficiary_employment_id}',
            path: {
                'beneficiary_employment_id': beneficiaryEmploymentId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's employment task status (self, token)
     * @param body Beneficiary employment task status
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryEmploymentTaskStatus(
        body?: api_updateBeneficiaryEmploymentTaskStatusRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/employment-task-status',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's equal opportunity data
     * @returns api_beneficiaryEqualOpportunityData OK
     * @throws ApiError
     */
    public static getBeneficiaryEqualOpportunityData(): CancelablePromise<api_beneficiaryEqualOpportunityData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/equal-opportunity-data',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's equal opportunity details (self, token)
     * @param body Beneficiary equal opportunity details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryEqualOpportunityData(
        body: api_beneficiaryEqualOpportunityData,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/equal-opportunity-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's essay data
     * @returns api_beneficiaryEssayData OK
     * @throws ApiError
     */
    public static getBeneficiaryEssayData(): CancelablePromise<api_beneficiaryEssayData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/essay-data',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's essay data (self, token)
     * @param body Beneficiary essay data
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryEssayData(
        body: api_updateBeneficiarySurveyData,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/essay-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's final award letter (self, token)
     * @param body Final award letter
     * @returns void
     * @throws ApiError
     */
    public static signFinalAwardLetter(
        body: api_signLetterRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/final-award-letter',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's gender (self, token)
     * @param body Beneficiary gender data
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryGender(
        body: api_updateBeneficiaryGenderRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/gender',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's health conditions (self, token)
     * @param body Beneficiary health conditions
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryHealthConditions(
        body: api_updateBeneficiaryHealthConditionsParams,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/health-conditions',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Details of authenticated beneficiary
     * @returns api_beneficiaryImmigrationData OK
     * @throws ApiError
     */
    public static getBeneficiaryImmigrationData(): CancelablePromise<api_beneficiaryImmigrationData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/immigration-data',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's immigration details (self, token)
     * @param body Beneficiary immigration details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryImmigrationData(
        body: api_beneficiaryImmigrationData,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/immigration-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List interview schedules for authenticated beneficiary
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListInterviewSchedulesRow OK
     * @throws ApiError
     */
    public static listBeneficiaryInterviewSchedules(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListInterviewSchedulesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/interview-schedules',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List interview slots for authenticated beneficiary
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListInterviewSlotsRow OK
     * @throws ApiError
     */
    public static listBeneficiaryInterviewSlots(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListInterviewSlotsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/interview-slots',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's interview slot (self, token)
     * @param body Beneficiary interview slot
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryInterviewSlotSelf(
        body: api_updateBeneficiaryInterviewSlotRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/interview-slots',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get interview slot details for authenticated beneficiary
     * @param id Interview slot ID
     * @returns db_GetInterviewSlotForBeneficiaryRow OK
     * @throws ApiError
     */
    public static getBeneficiaryInterviewSlot(
        id: number,
    ): CancelablePromise<db_GetInterviewSlotForBeneficiaryRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/interview-slots/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's letter data
     * @param letterTypeCode Letter type code
     * @param studyYear Study year
     * @returns db_GetBeneficiaryLetterRow OK
     * @throws ApiError
     */
    public static getBeneficiaryLetterSelf(
        letterTypeCode: string,
        studyYear: number,
    ): CancelablePromise<db_GetBeneficiaryLetterRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/letters/{letter_type_code}/{study_year}',
            path: {
                'letter_type_code': letterTypeCode,
                'study_year': studyYear,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Log out current beneficiary session
     * @returns void
     * @throws ApiError
     */
    public static logoutBeneficiary(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/beneficiaries/logout',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Details of authenticated beneficiary
     * @returns api_getAuthenticatedBeneficiaryResponse OK
     * @throws ApiError
     */
    public static getAuthenticatedBeneficiary(): CancelablePromise<api_getAuthenticatedBeneficiaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/me',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a beneficiary next of kin record
     * @param body Next of kin details
     * @returns api_createBeneficiaryNextOfKinResponse OK
     * @throws ApiError
     */
    public static createBeneficiaryNextOfKin(
        body: api_createBeneficiaryNextOfKinRequest,
    ): CancelablePromise<api_createBeneficiaryNextOfKinResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/next-of-kin',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List multiple beneficiaries' partners
     * @param beneficiaryIds Beneficiary IDs
     * @returns db_ListBeneficiaryPartnersByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryPartnersByBeneficiaryIDs(
        beneficiaryIds: Array<number>,
    ): CancelablePromise<Array<db_ListBeneficiaryPartnersByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/partners',
            query: {
                'beneficiary_ids': beneficiaryIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's passport data
     * @returns api_passportData OK
     * @throws ApiError
     */
    public static getBeneficiaryPassportData(): CancelablePromise<api_passportData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/passport-data',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's passport details (self, token)
     * @param body Beneficiary passport details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryPassportData(
        body: api_passportData,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/passport-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Export PDF of beneficiary application details
     * @returns binary OK
     * @throws ApiError
     */
    public static exportBeneficiaryApplicationSelf(): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/pdf/my-application',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Export PDFs of beneficiary details
     * @param body Beneficiary IDs and PDF sections
     * @returns api_createJobResponse OK
     * @throws ApiError
     */
    public static exportBeneficiaryList(
        body: api_exportApplicationPDFsParams,
    ): CancelablePromise<api_createJobResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/pdfs',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get pending task counts for beneficiaries
     * @param programmeCode Programme code (Chevening or Marshall)
     * @param isAssignedToMe Is assigned to current user
     * @returns db_GetBeneficiaryPendingTaskCountsRow OK
     * @throws ApiError
     */
    public static getBeneficiaryPendingTaskCounts(
        programmeCode: string,
        isAssignedToMe?: boolean,
    ): CancelablePromise<db_GetBeneficiaryPendingTaskCountsRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/pending-task-counts',
            query: {
                'is_assigned_to_me': isAssignedToMe,
                'programme_code': programmeCode,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's personal data
     * @returns api_beneficiaryPersonalData OK
     * @throws ApiError
     */
    public static getBeneficiaryPersonalData(): CancelablePromise<api_beneficiaryPersonalData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/personal-data',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's personal details (self, token)
     * @param body Beneficiary personal details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryPersonalData(
        body: api_beneficiaryPersonalData,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/personal-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's placement letter task (self, token)
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryPlacementLetterTaskStatus(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/placement-letter-task-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's post-scholarship plan
     * @returns api_beneficiaryPostScholarshipPlanData OK
     * @throws ApiError
     */
    public static getBeneficiaryPostScholarshipPlanData(): CancelablePromise<api_beneficiaryPostScholarshipPlanData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/post-scholarship-plan-data',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's post scholarship plan (self, token)
     * @param body Beneficiary post scholarship plan
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryPostScholarshipPlanData(
        body: api_beneficiaryPostScholarshipPlanData,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/post-scholarship-plan-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update programme officer of beneficiaries
     * @param body Beneficiary IDs and Programme Officer ID
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryProgrammeOfficers(
        body: api_updateBeneficiaryProgrammeOfficersRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/beneficiaries/programme-officers',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's proposed courses
     * @returns api_beneficiaryProposedCourseData OK
     * @throws ApiError
     */
    public static getBeneficiaryProposedCourseData(): CancelablePromise<api_beneficiaryProposedCourseData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/proposed-course-data',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's proposed course (self, token)
     * @param body Beneficiary proposed course
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryProposedCourseData(
        body: api_BeneficiaryProposedCourse,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/proposed-course-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's proposed course status (self, token)
     * @param body Beneficiary proposed course
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryProposedCourseStatus(
        body: api_updateBeneficiaryProposedCourseStatusRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/proposed-course-status',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's proposed course task status (self, token)
     * @param body Beneficiary proposed course
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryProposedCourseTaskStatus(
        body: api_BeneficiaryProposedCourseTask,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/proposed-course-task-status',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's proposed course is final (self, token)
     * @param id Beneficiary proposed course ID
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryProposedCourseIsProposedFinal(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/proposed-courses/{id}/is-proposed-final',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's publicity form task status (self, token)
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryPublicityFormTaskStatus(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/publicity-form-task-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's recommenders
     * @returns api_beneficiaryRecommenderData OK
     * @throws ApiError
     */
    public static getBeneficiaryRecommenderData(): CancelablePromise<api_beneficiaryRecommenderData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/recommender-data',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's recommender (self, token)
     * @param body Beneficiary recommender
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryRecommenderData(
        body: db_BeneficiaryRecommender,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/recommender-data',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's recommender task status (self, token)
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryRecommenderTaskStatus(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/recommender-task-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Beneficiary recovery details
     * @returns api_getBeneficiaryRecoveryDataResponse OK
     * @throws ApiError
     */
    public static getBeneficiaryRecoveryData(): CancelablePromise<api_getBeneficiaryRecoveryDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/recovery-data',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Reject applications
     * @param body Beneficiary IDs
     * @returns void
     * @throws ApiError
     */
    public static rejectApplications(
        body: api_rejectApplicationsRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/reject',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Renew a beneficiary session
     * @returns void
     * @throws ApiError
     */
    public static renewBeneficiarySession(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/renew-session',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Resend a beneficiary recommender email
     * @param body Recommender data
     * @returns void
     * @throws ApiError
     */
    public static resendRecommenderEmail(
        body: api_resendRecommenderEmailRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/resend-recommender-email',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Reset a beneficiary's data
     * @param body Email and token
     * @returns void
     * @throws ApiError
     */
    public static resetBeneficiaryData(
        body: api_resetBeneficiaryDataRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/reset',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Invite deferred beneficiaries to restart placement
     * @param body Beneficiary IDs
     * @returns void
     * @throws ApiError
     */
    public static resetDeferredPlacement(
        body: api_resetDeferredPlacementRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/reset-deferred-placement',
            body: body,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Email the beneficiary a link to restart their application
     * @returns void
     * @throws ApiError
     */
    public static sendBeneficiaryApplicationRestartEmail(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/send-application-restart-email',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send the beneficiary a recovery code via email
     * @param body Recovery email
     * @returns void
     * @throws ApiError
     */
    public static sendRecoveryCodeEmail(
        body: api_sendRecoveryCodeEmailRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/send-recovery-code-email',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send the beneficiary a recovery code via sms
     * @param body Phone number
     * @returns void
     * @throws ApiError
     */
    public static sendRecoveryCodeSms(
        body: api_sendRecoveryCodeSmsRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/send-recovery-code-sms',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send a task reminder email to beneficiaries
     * @param body Beneficiary IDs
     * @returns any OK
     * @throws ApiError
     */
    public static sendBeneficiaryReminderEmail(
        body: api_sendBeneficiaryReminderEmailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/send-reminder-email',
            body: body,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Request a new verification email for a beneficiary
     * @param body Beneficiary ID
     * @returns void
     * @throws ApiError
     */
    public static sendBeneficiaryTokenEmail(
        body: api_sendBeneficiaryTokenEmailRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/send-verification-email',
            body: body,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Details of unauthenticated beneficiary
     * @returns api_getUnauthenticatedBeneficiaryResponse OK
     * @throws ApiError
     */
    public static getUnauthenticatedBeneficiary(): CancelablePromise<api_getUnauthenticatedBeneficiaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/session',
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Share application with academic advisor
     * @param body Share with advisor data
     * @returns void
     * @throws ApiError
     */
    public static shareApplicationWithAdvisor(
        body: api_shareApplicationWithAdvisorRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/share-with-advisor',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Submit a beneficiary's application (self, token)
     * @param body Application submission data
     * @returns void
     * @throws ApiError
     */
    public static submitApplication(
        body: api_submitApplicationRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/submit-application',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Submit a recommendation for a beneficiary
     * @param beneficiaryRecommenderId Beneficiary recommender ID
     * @param documentFile Recommendation PDF
     * @param recommenderHasAgreed Recommender has agreed
     * @param token Token
     * @returns void
     * @throws ApiError
     */
    public static submitRecommendation(
        beneficiaryRecommenderId: number,
        documentFile: Blob,
        recommenderHasAgreed: boolean,
        token: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/submit-recommendation',
            formData: {
                'beneficiary_recommender_id': beneficiaryRecommenderId,
                'document_file': documentFile,
                'recommender_has_agreed': recommenderHasAgreed,
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Switch active application for authenticated applicant
     * @param id Award ID
     * @returns api_switchApplicationSessionResponse OK
     * @throws ApiError
     */
    public static switchApplicationSession(
        id: number,
    ): CancelablePromise<api_switchApplicationSessionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/switch-application/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of tasks for authenticated beneficiary
     * @returns api_listBeneficiaryTasksResponse OK
     * @throws ApiError
     */
    public static listBeneficiaryTasks(): CancelablePromise<api_listBeneficiaryTasksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/tasks',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's travel booking status (self, token)
     * @param body Travel booking status
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryTravelBookingStatus(
        body: api_updateBeneficiaryTravelBookingStatusRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/travel-booking-status',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate a beneficiary's access code
     * @param body Access code digits
     * @returns void
     * @throws ApiError
     */
    public static validateBeneficiaryAccessCode(
        body: api_validateBeneficiaryAccessCodeRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/validate-access-code',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate a beneficiary's email address
     * @param body Email
     * @returns void
     * @throws ApiError
     */
    public static validateBeneficiaryEmail(
        body: api_validateBeneficiaryEmailRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/validate-email',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate a beneficiary's kbv to access task list
     * @param body Date of Birth
     * @returns void
     * @throws ApiError
     */
    public static validateBeneficiaryKbv(
        body: api_validateBeneficiaryKBVRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/validate-kbv',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate a beneficiary's recovery code
     * @param body Recovery code
     * @returns api_validateRecoveryCodeResponse OK
     * @throws ApiError
     */
    public static validateRecoveryCode(
        body: api_validateRecoveryCodeRequest,
    ): CancelablePromise<api_validateRecoveryCodeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/validate-recovery-code',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate beneficiary IDs for rejection
     * @param body Beneficiary IDs
     * @returns db_GetBeneficiaryRejectionValidationCountsRow OK
     * @throws ApiError
     */
    public static validateBeneficiaryIDsForRejection(
        body: api_rejectApplicationsRequest,
    ): CancelablePromise<db_GetBeneficiaryRejectionValidationCountsRow> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/validate-rejections',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Verify a beneficiary's access code
     * @param body Access code
     * @returns api_verifyBeneficiaryAccessCodeResponse OK
     * @throws ApiError
     */
    public static verifyBeneficiaryAccessCode(
        body: api_verifyBeneficiaryAccessCodeRequest,
    ): CancelablePromise<api_verifyBeneficiaryAccessCodeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/verify-access-code',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Withdraw a beneficiary's application
     * @param body Email
     * @returns void
     * @throws ApiError
     */
    public static withdrawApplication(
        body: api_validateBeneficiaryEmailRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/withdraw-application',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Withdraw a beneficiary's offer
     * @param body Withdrawal details
     * @returns void
     * @throws ApiError
     */
    public static withdrawOffer(
        body: api_withdrawOfferRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/withdraw-offer',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary record
     * @param id Beneficiary ID
     * @returns db_GetBeneficiaryRow OK
     * @throws ApiError
     */
    public static getBeneficiary(
        id: number,
    ): CancelablePromise<db_GetBeneficiaryRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary record (admin, session)
     * @param id Beneficiary ID
     * @param body Beneficiary details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiary(
        id: number,
        body: api_updateBeneficiaryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary academic assessment record (admin, session)
     * @param id Beneficiary ID
     * @param body Beneficiary academic assessment details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryAcademicAssessment(
        id: number,
        body: api_updateBeneficiaryAcademicAssessmentRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/{id}/academic-assessment',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary assessment record
     * @param id Beneficiary ID
     * @param orderBy Assessor table order by, for previous/next
     * @param filters Assessor table filters, for previous/next
     * @param filterModes Assessor table filter modes, for previous/next
     * @param search Assessor table search string, for previous/next
     * @returns api_getBeneficiaryAssessmentResponse OK
     * @throws ApiError
     */
    public static getBeneficiaryAssessment(
        id: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<api_getBeneficiaryAssessmentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/assessment',
            path: {
                'id': id,
            },
            query: {
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's assessments
     * @param id Beneficiary ID
     * @returns api_listBeneficiaryAssessmentsByBeneficiaryIDResponse OK
     * @throws ApiError
     */
    public static listBeneficiaryAssessmentsByBeneficiaryId(
        id: number,
    ): CancelablePromise<api_listBeneficiaryAssessmentsByBeneficiaryIDResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/assessments',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's contact person
     * @param id Beneficiary ID
     * @param contactPersonTypeCode Contact person type code
     * @param body Beneficiary contact person details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryContactPerson(
        id: number,
        contactPersonTypeCode: string,
        body: api_updateBeneficiaryContactPersonRequestBody,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/beneficiaries/{id}/beneficiary-contact-persons/{contact_person_type_code}',
            path: {
                'id': id,
                'contact_person_type_code': contactPersonTypeCode,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a beneficiary employment record
     * @param id Beneficiary ID
     * @param body Employment details
     * @returns api_createBeneficiaryEmploymentResponse OK
     * @throws ApiError
     */
    public static createBeneficiaryEmployment(
        id: number,
        body: api_updateBeneficiaryEmploymentRequest,
    ): CancelablePromise<api_createBeneficiaryEmploymentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/beneficiary-employment',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary employment record
     * @param id Beneficiary ID
     * @param beneficiaryEmploymentId Beneficiary Employment ID
     * @returns db_GetBeneficiaryEmploymentRow OK
     * @throws ApiError
     */
    public static getBeneficiaryEmployment(
        id: number,
        beneficiaryEmploymentId: number,
    ): CancelablePromise<db_GetBeneficiaryEmploymentRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/beneficiary-employment/{beneficiary_employment_id}',
            path: {
                'id': id,
                'beneficiary_employment_id': beneficiaryEmploymentId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary employment record
     * @param id Beneficiary ID
     * @param beneficiaryEmploymentId Beneficiary Employment ID
     * @param body Employment details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryEmployment(
        id: number,
        beneficiaryEmploymentId: number,
        body: api_updateBeneficiaryEmploymentRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/beneficiary-employment/{beneficiary_employment_id}',
            path: {
                'id': id,
                'beneficiary_employment_id': beneficiaryEmploymentId,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary interaction history record
     * @param id Beneficiary ID
     * @param beneficiaryInteractionHistoryId Beneficiary InteractionHistory ID
     * @returns db_GetBeneficiaryInteractionHistoryRow OK
     * @throws ApiError
     */
    public static getBeneficiaryInteractionHistory(
        id: number,
        beneficiaryInteractionHistoryId: number,
    ): CancelablePromise<db_GetBeneficiaryInteractionHistoryRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/beneficiary-interaction-history/{beneficiary_interaction_history_id}',
            path: {
                'id': id,
                'beneficiary_interaction_history_id': beneficiaryInteractionHistoryId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary interaction history record
     * @param id Beneficiary ID
     * @param beneficiaryInteractionHistoryId Beneficiary InteractionHistory ID
     * @param body InteractionHistory details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryInteractionHistory(
        id: number,
        beneficiaryInteractionHistoryId: number,
        body: api_updateBeneficiaryInteractionHistoryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/{id}/beneficiary-interaction-history/{beneficiary_interaction_history_id}',
            path: {
                'id': id,
                'beneficiary_interaction_history_id': beneficiaryInteractionHistoryId,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's proposed course
     * @param id Beneficiary ID
     * @param beneficiaryProposedCourseId Beneficiary proposed course ID
     * @param body Beneficiary proposed course
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryProposedCourse(
        id: number,
        beneficiaryProposedCourseId: number,
        body: api_updateBeneficiaryProposedCourseRequestBody,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/{id}/beneficiary-proposed-courses/{beneficiary_proposed_course_id}',
            path: {
                'id': id,
                'beneficiary_proposed_course_id': beneficiaryProposedCourseId,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's proposed course is final
     * @param id Beneficiary ID
     * @param beneficiaryProposedCourseId Beneficiary proposed course ID
     * @param body Placement generation details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryProposedCourseIsFinal(
        id: number,
        beneficiaryProposedCourseId: number,
        body?: api_updateBeneficiaryProposedCourseIsFinalRequestBody,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/beneficiary-proposed-courses/{beneficiary_proposed_course_id}/is-final',
            path: {
                'id': id,
                'beneficiary_proposed_course_id': beneficiaryProposedCourseId,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary recommender record
     * @param id Beneficiary ID
     * @param beneficiaryRecommenderId Beneficiary Recommender ID
     * @returns api_getBeneficiaryRecommenderResponse OK
     * @throws ApiError
     */
    public static getBeneficiaryRecommender(
        id: number,
        beneficiaryRecommenderId: number,
    ): CancelablePromise<api_getBeneficiaryRecommenderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/beneficiary-recommenders/{beneficiary_recommender_id}',
            path: {
                'id': id,
                'beneficiary_recommender_id': beneficiaryRecommenderId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Submit a recommendation on behalf of a recommender (admin, session)
     * @param id Beneficiary ID
     * @param beneficiaryRecommenderId Beneficiary recommender ID
     * @param documentFile Recommendation PDF
     * @param recommenderHasAgreed Recommender has agreed
     * @param unsubmit Unsubmit recommendation
     * @returns void
     * @throws ApiError
     */
    public static submitBeneficiaryRecommendationAsAdvisor(
        id: number,
        beneficiaryRecommenderId: number,
        documentFile?: Blob,
        recommenderHasAgreed?: boolean,
        unsubmit?: boolean,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/beneficiary-recommenders/{beneficiary_recommender_id}/submit',
            path: {
                'id': id,
                'beneficiary_recommender_id': beneficiaryRecommenderId,
            },
            formData: {
                'document_file': documentFile,
                'recommender_has_agreed': recommenderHasAgreed,
                'unsubmit': unsubmit,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's budget lines
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryBudgetByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryBudgetByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryBudgetByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/budget',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary budget record (admin, session)
     * @param id Beneficiary ID
     * @param body Beneficiary budget details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryBudget(
        id: number,
        body: api_updateBeneficiaryBudgetRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/{id}/budget',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's committee assessments
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryCommitteeAssessmentsRow OK
     * @throws ApiError
     */
    public static listBeneficiaryCommitteeAssessmentsByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryCommitteeAssessmentsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/committee-assessments',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary committee assessment record
     * @param id Beneficiary ID
     * @param committeeId Committee ID
     * @returns api_getBeneficiaryCommitteeAssessmentResponse OK
     * @throws ApiError
     */
    public static getBeneficiaryCommitteeAssessment(
        id: number,
        committeeId: number,
    ): CancelablePromise<api_getBeneficiaryCommitteeAssessmentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/committees/{committee_id}/committee-assessment',
            path: {
                'id': id,
                'committee_id': committeeId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's contact person
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryContactPersonByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryContactPersonByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryContactPersonByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/contact-person',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's contacts
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryContactsByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryContactsByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryContactsByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/contacts',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's documents
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryDocumentsByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryDocumentsByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryDocumentsByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/documents',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary document
     * @param id Beneficiary ID
     * @param documentFile Document file
     * @param documentType Document type
     * @returns api_updateBeneficiaryDocumentSelfResponse OK
     * @throws ApiError
     */
    public static updateBeneficiaryDocument(
        id: number,
        documentFile?: Blob,
        documentType?: string,
    ): CancelablePromise<api_updateBeneficiaryDocumentSelfResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/documents',
            path: {
                'id': id,
            },
            formData: {
                'document_file': documentFile,
                'document_type': documentType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's education history
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryEducationHistoryByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryEducationHistoryByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryEducationHistoryByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/education-history',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of beneficiary eligibility statuses
     * @param id Beneficiary ID
     * @returns db_GetBeneficiaryEligibilityStatusesRow OK
     * @throws ApiError
     */
    public static getBeneficiaryEligibilityStatuses(
        id: number,
    ): CancelablePromise<Array<db_GetBeneficiaryEligibilityStatusesRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/eligibility-statuses',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a beneficiary eligibility verification record
     * @param id Beneficiary ID
     * @param body Eligibility verification details
     * @returns api_createBeneficiaryEligibilityVerificationResponse OK
     * @throws ApiError
     */
    public static createBeneficiaryEligibilityVerification(
        id: number,
        body: api_createBeneficiaryEligibilityVerificationRequest,
    ): CancelablePromise<api_createBeneficiaryEligibilityVerificationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/eligibility-verification',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List beneficiary email
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryEmailByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryEmailByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryEmailByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/emails',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update beneficiary email records (admin, session)
     * @param id Beneficiary ID
     * @param body Beneficiary email details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryEmail(
        id: number,
        body: api_updateBeneficiaryEmailRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/emails',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's employment
     * @param id Beneficiary ID
     * @returns api_listBeneficiaryEmploymentByBeneficiaryIDResponse OK
     * @throws ApiError
     */
    public static listBeneficiaryEmploymentByBeneficiaryId(
        id: number,
    ): CancelablePromise<api_listBeneficiaryEmploymentByBeneficiaryIDResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/employment',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update an endorsement for a beneficiary
     * @param id Beneficiary ID
     * @param documentId Document ID (if updating without changing the file)
     * @param documentFile Endorsement letter PDF
     * @param endorsementClassRank Class rank
     * @param endorsementComparisonRank Comparison rank
     * @param endorsementComparisonCount Comparison count
     * @param endorsementRankProcess Rank process
     * @param endorserFirstName Endorser first name
     * @param endorserLastName Endorser last name
     * @param endorserJobTitle Endorser job title
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryEndorsement(
        id: number,
        documentId?: number,
        documentFile?: Blob,
        endorsementClassRank?: string,
        endorsementComparisonRank?: string,
        endorsementComparisonCount?: string,
        endorsementRankProcess?: string,
        endorserFirstName?: string,
        endorserLastName?: string,
        endorserJobTitle?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/endorsement',
            path: {
                'id': id,
            },
            formData: {
                'document_id': documentId,
                'document_file': documentFile,
                'endorsement_class_rank': endorsementClassRank,
                'endorsement_comparison_rank': endorsementComparisonRank,
                'endorsement_comparison_count': endorsementComparisonCount,
                'endorsement_rank_process': endorsementRankProcess,
                'endorser_first_name': endorserFirstName,
                'endorser_last_name': endorserLastName,
                'endorser_job_title': endorserJobTitle,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Endorse and submit application for a beneficiary
     * @param id Beneficiary ID
     * @returns void
     * @throws ApiError
     */
    public static submitBeneficiaryEndorsement(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/endorsement/submit',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's ethnicities
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryEthnicityByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryEthnicityByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryEthnicityByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/ethnicities',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update beneficiary flags (admin, session)
     * @param id Beneficiary ID
     * @param body Flag IDs
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryFlag(
        id: number,
        body: api_updateBeneficiaryFlagRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/flags',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's interaction history
     * @param id Beneficiary ID
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param search Search string
     * @returns db_ListBeneficiaryInteractionHistoryRow OK
     * @throws ApiError
     */
    public static listBeneficiaryInteractionHistory(
        id: number,
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListBeneficiaryInteractionHistoryRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/interaction-history',
            path: {
                'id': id,
            },
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a beneficiary interaction history record
     * @param id Beneficiary ID
     * @param body Interaction details
     * @returns api_createBeneficiaryInteractionHistoryResponse OK
     * @throws ApiError
     */
    public static createBeneficiaryInteractionHistory(
        id: number,
        body: api_createBeneficiaryInteractionHistoryRequest,
    ): CancelablePromise<api_createBeneficiaryInteractionHistoryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/interaction-history',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's interests
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryInterestByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryInterestByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryInterestByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/interests',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update beneficiary interest records (admin, session)
     * @param id Beneficiary ID
     * @param body Beneficiary interest details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryInterest(
        id: number,
        body: api_updateBeneficiaryInterestRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/interests',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary interview outcome record
     * @param id Beneficiary ID
     * @returns db_GetInterviewOutcomeByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static getBeneficiaryInterviewOutcome(
        id: number,
    ): CancelablePromise<db_GetInterviewOutcomeByBeneficiaryIDRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/interview-outcomes',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a beneficiary interview outcome record
     * @param id Beneficiary ID
     * @param body Interview outcome details
     * @returns api_createBeneficiaryInterviewOutcomeResponse OK
     * @throws ApiError
     */
    public static createBeneficiaryInterviewOutcome(
        id: number,
        body: api_createBeneficiaryInterviewOutcomeRequest,
    ): CancelablePromise<api_createBeneficiaryInterviewOutcomeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/interview-outcomes',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's interview slot
     * @param id Beneficiary ID
     * @param body Beneficiary interview slot
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryInterviewSlot(
        id: number,
        body: api_updateBeneficiaryInterviewSlotRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/{id}/interview-slots',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Preview the Marshall interview invitation letter for a not-yet-booked interview slot
     * @param id Beneficiary ID
     * @param interviewSlotId Interview slot ID
     * @returns api_previewBeneficiaryInterviewLetterResponse OK
     * @throws ApiError
     */
    public static previewBeneficiaryInterviewLetter(
        id: number,
        interviewSlotId: number,
    ): CancelablePromise<api_previewBeneficiaryInterviewLetterResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/interview-slots/{interview_slot_id}/letter-preview',
            path: {
                'id': id,
                'interview_slot_id': interviewSlotId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a signature image for the Marshall interview invitation letter preview
     * @param id Beneficiary ID
     * @param interviewSlotId Interview slot ID
     * @param signatureType Signature type
     * @returns void
     * @throws ApiError
     */
    public static getBeneficiaryInterviewLetterSignature(
        id: number,
        interviewSlotId: number,
        signatureType: 'lead' | 'chair',
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/interview-slots/{interview_slot_id}/letter-preview/signatures/{signature_type}',
            path: {
                'id': id,
                'interview_slot_id': interviewSlotId,
                'signature_type': signatureType,
            },
            errors: {
                307: `Temporary Redirect`,
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                502: `Bad Gateway`,
            },
        });
    }
    /**
     * Update a beneficiary's letter
     * @param id Beneficiary ID
     * @param letterTypeCode Letter type code
     * @param body Beneficiary letter details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryLetter(
        id: number,
        letterTypeCode: string,
        body: api_updateBeneficiaryLetterRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/letters/{letter_type_code}',
            path: {
                'id': id,
                'letter_type_code': letterTypeCode,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary letter record
     * @param id Beneficiary ID
     * @param letterTypeCode Letter type code
     * @param studyYear Study year
     * @returns db_GetBeneficiaryLetterRow OK
     * @throws ApiError
     */
    public static getBeneficiaryLetter(
        id: number,
        letterTypeCode: string,
        studyYear?: number,
    ): CancelablePromise<db_GetBeneficiaryLetterRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/letters/{letter_type_code}/{study_year}',
            path: {
                'id': id,
                'letter_type_code': letterTypeCode,
                'study_year': studyYear,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's next of kin
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryNextOfKinByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryNextOfKinByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryNextOfKinByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/next-of-kin',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's partners
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryPartnersByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryPartnersByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryPartnersByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/partners',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a beneficiary partner record
     * @param id Beneficiary ID
     * @param body Partner details
     * @returns void
     * @throws ApiError
     */
    public static createBeneficiaryPartner(
        id: number,
        body: api_createBeneficiaryPartnerRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/partners',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a beneficiary partner record
     * @param id Beneficiary ID
     * @param body Partner details
     * @returns void
     * @throws ApiError
     */
    public static deleteBeneficiaryPartner(
        id: number,
        body: api_createBeneficiaryPartnerRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/beneficiaries/{id}/partners',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Export PDF of beneficiary application details
     * @param sections Comma-separated PDF section codes (Marshall only). Omit for the default set.
     * @returns binary OK
     * @throws ApiError
     */
    public static exportBeneficiaryApplicationS(
        sections?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/pdf',
            query: {
                'sections': sections,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get placement form of a beneficiary
     * @param id Beneficiary ID
     * @param studyYear Study Year
     * @returns db_GetBeneficiaryPlacementRow OK
     * @throws ApiError
     */
    public static getBeneficiaryPlacement(
        id: number,
        studyYear?: number,
    ): CancelablePromise<db_GetBeneficiaryPlacementRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/placement',
            path: {
                'id': id,
            },
            query: {
                'study_year': studyYear,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's placement form
     * @param id Beneficiary ID
     * @param body Beneficiary placement details
     * @param studyYear Study Year
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryPlacement(
        id: number,
        body: api_updateBeneficiaryPlacementRequest,
        studyYear?: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/{id}/placement',
            path: {
                'id': id,
            },
            query: {
                'study_year': studyYear,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get placement status of a beneficiary
     * @param id Beneficiary ID
     * @returns api_getBeneficiaryPlacementStatusResponse OK
     * @throws ApiError
     */
    public static getBeneficiaryPlacementStatus(
        id: number,
    ): CancelablePromise<api_getBeneficiaryPlacementStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/placement-status',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's placement status
     * @param id Beneficiary ID
     * @param beneficiaryStatusId Beneficiary status ID
     * @param studyYear Study year
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryPlacementStatus(
        id: number,
        beneficiaryStatusId: number,
        studyYear?: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/placement-status/{beneficiary_status_id}',
            path: {
                'id': id,
                'beneficiary_status_id': beneficiaryStatusId,
            },
            query: {
                'study_year': studyYear,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get placement form by placement token
     * @param id Beneficiary ID
     * @param token Placement token
     * @returns db_GetBeneficiaryPlacementRow OK
     * @throws ApiError
     */
    public static getBeneficiaryPlacementByToken(
        id: number,
        token: string,
    ): CancelablePromise<db_GetBeneficiaryPlacementRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/placement-token/{token}',
            path: {
                'id': id,
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary placement by placement token
     * @param id Beneficiary ID
     * @param token Placement token
     * @param body Beneficiary placement details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryPlacementByToken(
        id: number,
        token: string,
        body: api_updateBeneficiaryPlacementRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/beneficiaries/{id}/placement-token/{token}',
            path: {
                'id': id,
                'token': token,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Export PDF of beneficiary placement form details
     * @param id Beneficiary ID
     * @returns binary OK
     * @throws ApiError
     */
    public static exportBeneficiaryPlacementPdf(
        id: number,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/placement/pdf',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's proposed courses
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryProposedCoursesByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryProposedCourseByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryProposedCoursesByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/proposed-courses',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's recommenders
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryRecommendersByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryRecommenderByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryRecommendersByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/recommenders',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's recommender (admin, session)
     * @param id Beneficiary ID
     * @param body Beneficiary recommender
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryRecommender(
        id: number,
        body: db_ListBeneficiaryRecommendersByBeneficiaryIDRow,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/recommenders',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary recovery code
     * @param id Beneficiary ID
     * @returns api_getBeneficiaryRecoveryCodeResponse OK
     * @throws ApiError
     */
    public static getBeneficiaryRecoveryCode(
        id: number,
    ): CancelablePromise<api_getBeneficiaryRecoveryCodeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/recovery-code',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Return application to a beneficiary
     * @param id Beneficiary ID
     * @param body Return Reason
     * @returns void
     * @throws ApiError
     */
    public static returnApplication(
        id: number,
        body: api_returnApplicationRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/return-application',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send placement letter to a beneficiary
     * @param id Beneficiary ID
     * @returns void
     * @throws ApiError
     */
    public static sendPlacementLetter(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/send-placement-letter',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List beneficiary social media
     * @param id Beneficiary ID
     * @returns db_BeneficiaryBeneficiarySocialMedium OK
     * @throws ApiError
     */
    public static listBeneficiarySocialMediaByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_BeneficiaryBeneficiarySocialMedium>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/social-media',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update beneficiary social media records (admin, session)
     * @param id Beneficiary ID
     * @param body Beneficiary social media details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiarySocialMedia(
        id: number,
        body: api_updateBeneficiarySocialMediaRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/social-media',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List beneficiary special statuses
     * @param id Beneficiary ID
     * @returns db_DropdownSpecialStatus OK
     * @throws ApiError
     */
    public static listBeneficiarySpecialStatusByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_DropdownSpecialStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/special-statuses',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's study years
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryStudyYearByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryStudyYearByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryStudyYearByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/study-years',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update study year of a beneficiary
     * @param id Beneficiary ID
     * @param body Beneficiary Study Year Details
     * @returns void
     * @throws ApiError
     */
    public static updateBeneficiaryStudyYear(
        id: number,
        body: api_updateBeneficiaryStudyYearRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/beneficiaries/{id}/study-years',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's tags
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryTagsByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryTagsByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryTagsByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/tags',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary's tasks
     * @param id Beneficiary ID
     * @returns db_BeneficiaryTaskMap OK
     * @throws ApiError
     */
    public static getBeneficiaryTasks(
        id: number,
    ): CancelablePromise<db_BeneficiaryTaskMap> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/tasks',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List a beneficiary's travel details
     * @param id Beneficiary ID
     * @returns db_ListBeneficiaryTravelByBeneficiaryIDRow OK
     * @throws ApiError
     */
    public static listBeneficiaryTravelByBeneficiaryId(
        id: number,
    ): CancelablePromise<Array<db_ListBeneficiaryTravelByBeneficiaryIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/travel',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate a beneficiary recommender token
     * @param id Beneficiary Recommender ID
     * @param token Token
     * @returns api_validateRecommenderTokenResponse OK
     * @throws ApiError
     */
    public static validateRecommenderToken(
        id: number,
        token: string,
    ): CancelablePromise<api_validateRecommenderTokenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/validate-recommender-token/{token}',
            path: {
                'id': id,
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate beneficiary task
     * @param id Beneficiary ID
     * @param body Task details
     * @returns void
     * @throws ApiError
     */
    public static validateBeneficiaryTask(
        id: number,
        body: api_validateBeneficiaryTaskRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/beneficiaries/{id}/validate-task',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a beneficiary record
     * @param id Beneficiary ID
     * @param token Beneficiary Token
     * @returns api_validateBeneficiaryTokenResponse OK
     * @throws ApiError
     */
    public static validateBeneficiaryToken(
        id: number,
        token: string,
    ): CancelablePromise<api_validateBeneficiaryTokenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/beneficiaries/{id}/validate-token/{token}',
            path: {
                'id': id,
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a beneficiary's transcript (self, token)
     * @param id Beneficiary Education History ID
     * @param file File to be uploaded
     * @returns void
     * @throws ApiError
     */
    public static updateTranscript(
        id: number,
        file: Blob,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/transcript/{id}',
            path: {
                'id': id,
            },
            formData: {
                'file': file,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate a beneficiary education history token
     * @param id Beneficiary Education History ID
     * @param token Token
     * @returns api_validateEducationHistoryTokenResponse OK
     * @throws ApiError
     */
    public static validateEducationHistoryToken(
        id: number,
        token: string,
    ): CancelablePromise<api_validateEducationHistoryTokenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/transcript/{id}/{token}',
            path: {
                'id': id,
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
